import React from 'react';
export function LimitedTimeOffer() {
  return <p className="text-[#FF6B35] font-bold text-center mb-4" data-id="element-407">
      This <span className="text-gray-500 line-through mr-1" data-id="element-408">$70</span>$29 new
      member offer is only available during this month for a limited time. After
      that, it returns to the regular $70 price.
    </p>;
}